import {Dispatch} from 'react'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {
  getActividadesEconomicas,
  getCondicionOperacionCAT016,
  getDepartamentos,
  getTipoEstablecimiento,
  getTipoPersona,
  getTiposDocumento,
  getTiposDocumentoEmision,
  setDatosGeneralesEmisor,
  getUnidadesMedida,
  getImpuestosProducto,
  getPlazosPago,
  getTiposCargoMembresia,
  getCondicionesPago,
  getFormasPago,
  getBancos,
  getSuscripciones,
  getServiciosAdicionales,
  getCatalogosProductos
} from '../catalogos.actions'
import {generalOpenModalError, generalShowLoader, getFechaHora} from '../general.actions'
import { getLogoEmpresa } from '../operaciones/operaciones.actions'
import { getConfigData, userSaveLogo } from '../userLogin.actions'
import { State } from '../../reducers'
import { perfilGetDataUser } from '../perfil/profile.actions'

export const facturacionGetDatosEmisor = () => async (dispatch: Dispatch<any>) => {
  await http
    .get(ENDPOINTS.FACTURACION_GET_EMPRESA_EMISOR, {}, KEYS.TOKEN)
    .then(async (res: any) => {
      if (res?.message) return dispatch(generalOpenModalError(res.message))
      const response = {
        ...res.body,
        departamento: {
          idDepartamento: res?.body?.departamento,
          valor: res?.body?.departamentonombre,
        },
        municipio: {
          idMmunicipio: res?.body?.municipio,
          valor: res?.body?.municipionombre,
        },
      }
      dispatch(setDatosGeneralesEmisor(response))
    })
    .catch((err) => {
      let message = 'No se logró obtener los datos del Emisor'
      dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
    })
}

export const peticionesGenerales = (cargarExportacion?: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
  const {datos: userData} = getState().userLogin;
  try {
    Promise.all([
      dispatch(getConfigData()),
      dispatch(getCondicionesPago()),
      dispatch(getFormasPago()),
      dispatch(getPlazosPago()),
      dispatch(getTiposCargoMembresia()),
      dispatch(getBancos()),
      dispatch(getUnidadesMedida()),
      dispatch(getImpuestosProducto()),
      dispatch(getDepartamentos()),
      dispatch(getActividadesEconomicas()),
      dispatch(getTipoEstablecimiento()),
      dispatch(getTipoPersona()),
      dispatch(getTiposDocumento()),
      dispatch(getTiposDocumentoEmision()),
      dispatch(facturacionGetDatosEmisor()),
      dispatch(refreshLogo()),
      dispatch(getCondicionOperacionCAT016()),
      dispatch(getFechaHora()),
      dispatch(getSuscripciones()),
      dispatch(getServiciosAdicionales()),
      dispatch(perfilGetDataUser(userData.username)),
      dispatch(getCatalogosProductos(userData.codigo_empresa, userData.sucursal_seleccionada)),
      cargarExportacion(),
    ])
  } catch (error) {}
}

export const refreshLogo = () => async (dispatch: Dispatch<any>) => {
    const uniqueUrlImagen = `${getLogoEmpresa()}?timestamp=${new Date().getTime()}`;
    const maxAttempts = 20;
    const delay = 2000;
    
    for (let actualAttempts = 0; actualAttempts < maxAttempts; actualAttempts++) {
      try {
        const response = await fetch(uniqueUrlImagen);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          const base64data = reader.result;
          if (base64data) {
            dispatch(userSaveLogo(base64data))
          }
        }
        reader.readAsDataURL(blob);
        // Si la respuesta está bien, salir del bucle.
        break;
      } catch (err) {
        // Si es el último intento, re-lanzar el error.
        if (actualAttempts === maxAttempts - 1) throw err;
        
        // Esperar antes del próximo intento.
        await new Promise(res => setTimeout(res, delay));
      }
    }
  }

export const obtenerUsernameAleatorio =
  (first_name: string, last_name: string) => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true))
    const body = {
      first_name: first_name.trim(),
      last_name: last_name.trim(),
    }
    return await http
      .post(ENDPOINTS.OBTENER_USERNAME, body)
      .then(async (res: any) => {
        if (res.status === 200) return res.data
        return ''
      })
      .catch(async (err: any) => {
        return ''
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

export const validarUsername = (username: string) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true))
  const body = {username: username.trim()}
  let message = 'Nombre de Usuario Incorrecto'
  return await http
    .post(ENDPOINTS.VERIFICAR_SOLO_USERNAME, body)
    .then(async (res: any) => {
      if (res.status === 200) return 'true'
      await dispatch(generalOpenModalError(res.message ?? message))
      return res.message ?? message
    })
    .catch(async (err: any) => {
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return err?.response?.data?.message ?? message
    })
    .finally(() => dispatch(generalShowLoader(false)))
}

export const validarUsernameConDoc = (username: string, codigo_empresa: string, id_number: string, type_id_number?: string) => async (dispatch: Dispatch<any>) => {
  dispatch(generalShowLoader(true))
  const body = {
    username: username.trim(), 
    type_id_number: type_id_number ? type_id_number.trim() : "", 
    id_number: id_number.trim(),
    codigo_empresa: codigo_empresa.trim(),
  }

  let message = 'Nombre de Usuario Incorrecto'
  return await http
    .post(ENDPOINTS.VALIDAR_USERNAME, body)
    .then(async (res: any) => {
      if (res.status === 200) return 'true'
      await dispatch(generalOpenModalError(res.message ?? message))
      return res.message ?? message
    })
    .catch(async (err: any) => {
      await dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      return err?.response?.data?.message ?? message
    })
    .finally(() => dispatch(generalShowLoader(false)))
}
